const TYPES = {
  NEW_FEATURE: 'New Feature',
  IMPROVEMENT: 'Improvement',
  BUG_FIX: 'Bug Fix',
};

export const getSchema = dealers => ({
  title: 'Announcement',
  type: 'object',
  required: ['title', 'type', 'content', 'version'],
  properties: {
    title: { type: 'string', title: 'Title', maxLength: 100 },
    type: { type: 'string', title: 'Type', enum: Object.values(TYPES) },
    version: { type: 'string', title: 'Version', maxLength: 10 },
    content: { type: 'string', title: 'Content', maxLength: 255 },
    limitToList: {
      type: 'array',
      title: 'Dealers',
      items: {
        type: 'string',
        enum: dealers.map(d => d.id),
        enumNames: dealers.map(d => d.name),
      },
      uniqueItems: true,
    },
  },
});

export const uiSchema = {
  limitToList: {
    'ui:widget': 'checkboxes',
    classNames: 'col-md-12',
  },
  title: {
    classNames: 'col-md-6',
  },
  type: {
    classNames: 'col-md-4',
  },
  version: {
    classNames: 'col-md-2',
  },
  content: {
    classNames: 'col-md-12',
  },
};
